import {Link} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Email from '@material-ui/icons/Email';
import {default as PropTypes, default as t} from 'prop-types';
import {path, pathOr} from 'ramda';
import React from 'react';
import styled from 'styled-components';
import {Text} from '../../atoms/Text';
import {withMetrics} from '../../metrics';
import TabBar from '../../molecules/TabBar';
import {SystemSideBar} from '../../organisms';
import AlarmHistory from '../../organisms/AlarmHistory';
import Documents from '../../organisms/Documents';
import {SystemMaintenanceHistory} from '../../organisms/MaintenanceHistory';
import OperatorsList from '../../organisms/OperatorsList';
import TransferHistory from '../../organisms/TransferHistory';
import {SystemDetailsContainer} from './styles';

const MailToButton = styled(Button)`
  background-color: ${props => props.theme.colors.primary};
  text-transform: capitalize;
  &:hover {
    background-color: ${props => props.theme.colors.lightBlue};
  }
  &:disabled {
    opacity: 0.4;
  }
`;

const MailToLink = styled(Link)`
  margin-left: auto;
  display: flex;
  color: red;
  text-decoration: none;
  &:hover {
    text-decoration: none !important;
  }
  &:visited {
    color: white;
  }
`;

const SystemDetailsMainContainer = styled.div`
  flex: 1;
  padding: 80px 40px;
  display: flex;
  flex-direction: column;
`;

const tabs = [
  {
    title: 'alarms',
    Component: AlarmHistory,
  },
  {
    title: 'operators',
    Component: OperatorsList,
  },
  {
    title: 'transfers',
    Component: TransferHistory,
  },
  {
    title: 'maintenance',
    Component: SystemMaintenanceHistory,
  },
  {
    title: 'documents',
    Component: Documents,
  },
];

class SystemDetailsMain extends React.Component {
  state = {
    selectedTab: 0,
  };

  setSelectedTab = selectedTab => this.setState({selectedTab});

  renderTabContent = selectedTab => {
    const tab = tabs[selectedTab];
    const {Component} = tab;
    return <Component />;
  };

  getMailToUrl = () => {
    const system = this.props.system;
    const emails = pathOr([], ['project', 'client', 'email'], system);
    const vessel = path(['project', 'vessel'], system);
    if (!(system && vessel && emails.length)) {
      return null;
    }
    const cc = 'occ@ampelmann.nl';
    const subject = `Downtime Start Ampelmann ${system.id} / ${vessel}`;
    return encodeURI(`mailto:${emails.join(',')}?cc=${cc}&subject=${subject}`);
  };

  render() {
    const {selectedTab} = this.state;
    const mailToUrl = this.getMailToUrl();
    return (
      <SystemDetailsMainContainer>
        <div style={{display: 'flex'}}>
          <TabBar
            tabs={tabs}
            onSelect={(_, i) => this.setSelectedTab(i)}
            selected={selectedTab}
          />
          <MailToLink href={mailToUrl}>
            <MailToButton disabled={!mailToUrl}>
              <Email style={{color: 'white', marginRight: '8px'}} />
              <Text style={{color: 'white', marginTop: '2px'}}>
                Update clients
              </Text>
            </MailToButton>
          </MailToLink>
        </div>
        <div
          style={{
            marginTop: '40px',
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
          }}
        >
          {this.renderTabContent(selectedTab)}
        </div>
      </SystemDetailsMainContainer>
    );
  }
}

SystemDetailsMain.propTypes = {
  system: t.object,
};

const SystemDetailsPage = ({system, loading}) => (
  <SystemDetailsContainer>
    <SystemSideBar system={system} loading={loading} />
    <SystemDetailsMain system={system} />
  </SystemDetailsContainer>
);

SystemDetailsPage.propTypes = {
  system: PropTypes.object,
  loading: PropTypes.bool,
};

export default withMetrics(SystemDetailsPage, 'SystemDetailsPage');
